import React, { useMemo } from 'react';
import { OChartBase, withChartTheme } from './OChartBase';
import { ECHARTS_COLOR_PALETTE } from '../Hooks/useColorArrayHooks';

/**
 * OBarChart - standardized bar chart with theme and safe defaults
 */
const OBarChart = ({ options, minHeight, maxHeight, style, theme }) => {
	const merged = useMemo(() => {
		const baseOptions = {
			color: ECHARTS_COLOR_PALETTE,
			tooltip: {
				trigger: 'axis',
				axisPointer: { type: 'shadow' },
			},
			legend: { type: 'scroll', bottom: 10 },
			// ensure horizontal grid lines are visible and light
			yAxis: [{ splitLine: { show: true } }],
		};
		return withChartTheme({ ...baseOptions, ...(options || {}) }, theme);
	}, [options, theme]);

	return (
		<OChartBase
			options={merged}
			minHeight={minHeight}
			maxHeight={maxHeight}
			style={style}
		/>
	);
};

export default OBarChart;
